import { useQuery } from '@tanstack/react-query'
import { requestV3 } from 'Features/Auth/axios-client'

interface FetchAllocationArgs {
  projectId: string
  scenarioId: string
}

// fetch product allocation.
const fetchProductAllocation = async (
  projectId: string,
  scenarioId: string
) => {
  const { data } = await requestV3({
    url: `/product-allocation?project_id=${projectId}&scenario_id=${scenarioId}`,
  })
  return data
}

export const useProductAllocation = ({
  projectId,
  scenarioId,
}: FetchAllocationArgs) => {
  return useQuery({
    queryKey: ['productAllocation', projectId, scenarioId],
    queryFn: () => fetchProductAllocation(projectId, scenarioId),
    select: (data) => data,
    gcTime: Infinity,
  })
}
